import { createSlice } from "@reduxjs/toolkit";
import { getListZaloEvent } from "../../api/zaloEvent/zaloEvent";

// giá trị khởi tạo của state
const initialState = {
  listZaloEvents: [],
  isLoadZaloEvent: false,
  currentPage: 1,
  pageSize: 10,
  // hasFetchedData: false,
  error: null,
  totalRecords: 0, // Tổng số bản ghi từ API  
};

const zaloEventSlice = createSlice({
  name: "zaloEvent", // tên phân biệt giữa các reduce
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    // setHasFetchedData: (state, action) => {
    //   state.hasFetchedData = action.payload;
    // },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload; // Sửa lỗi gán nhầm `pageSize`
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListZaloEvent.pending, (state) => {// api đnag pending chờ xử lý
        state.isLoadZaloEvent = true;
        state.error = null;
      })
      .addCase(getListZaloEvent.fulfilled, (state, action) => {// api trả về thành công thì trả ra
        state.isLoadZaloEvent = false;
        state.listZaloEvents = action.payload.data || [];

        state.isLoadZaloEvent = false;
        // state.hasFetchedData = true;
        state.currentPage = action.payload.current_page; // Cập nhật trang hiện tại từ API
        state.pageSize = action.payload.per_page; // Cập nhật số bản ghi mỗi trang
        state.totalRecords = action.payload.total; // Cập nhật tổng số bản ghi
      })
      .addCase(getListZaloEvent.rejected, (state, action) => {// api trả về thất bại thì trả ra
        state.isLoadZaloEvent = false;
        state.error = action.payload;
        // state.error = action.error?.message || "Lỗi không xác định";
      });
  },
});

// export const { setCurrentPage, setPageSize, setHasFetchedData } = zaloEventSlice.actions;
export const { setCurrentPage, setPageSize, setTotalRecords } = zaloEventSlice.actions;
export default zaloEventSlice.reducer;
